import React, { useContext, useEffect, useState } from 'react';
import { GetUserContext } from '../Context/GetUserContext';
import SignupSection from '../Components/PageSignup/SignupSection';
import './PageSignup.css'

const PageSignup = () => {
    const { pageIsLogin, setPageIsLogin } = useContext(GetUserContext);


    useEffect(() => {
        setPageIsLogin(true)
    }, [pageIsLogin, setPageIsLogin])

    return (
        <div className='area-main-login'>
            <SignupSection />
        </div>
    )
}

export default PageSignup